import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=77fae46c&scoped=true&"
import script from "./memo.vue?vue&type=script&lang=js&"
export * from "./memo.vue?vue&type=script&lang=js&"
import style0 from "./memo.vue?vue&type=style&index=0&id=77fae46c&scoped=true&lang=less&"
import style1 from "./memo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fae46c",
  null
  
)

export default component.exports